/**
 * Which model the assistant opens with.
 *
 * Three sources, in order: the user's saved choice, the worker's own default, then
 * whatever the catalogue offers first. The fallbacks matter because a saved
 * preference outlives the catalogue — a model can be retired, or the preference can
 * predate a change — and a picker holding a dead id would silently send requests
 * that fall back server-side without the user understanding why.
 */

export const DEFAULT_MODEL_PREF_KEY = "defaultAssistantModel";

export function resolveDefaultModel(
  saved: string | undefined,
  workerDefault: string | undefined,
  available: { id: string }[],
): string | undefined {
  const offered = (id: string | undefined) =>
    id != null && (available.length === 0 || available.some((m) => m.id === id));

  if (offered(saved)) return saved;
  if (offered(workerDefault)) return workerDefault;
  return available[0]?.id;
}

/**
 * Sets one key without disturbing the rest.
 *
 * The preferences API is a full replace, so anything dropped here is genuinely lost
 * — app order, hidden links, board content all live in the same object.
 */
export function mergePreference(
  existing: Record<string, unknown> | undefined,
  key: string,
  value: unknown,
): Record<string, unknown> {
  return { ...(existing ?? {}), [key]: value };
}
